import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import Header from "./Header";
import Footer from "./Footer";

/** Shared shell for static legal pages. Keeps typography consistent and gives
 *  every page a "back to home" link, an effective-date row, and a printable
 *  layout. Child renders the body in semantic HTML. */
export default function LegalPage({ eyebrow, title, intro, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen bg-white" data-testid={testid}>
      <Header />
      <article className="max-w-3xl mx-auto px-5 lg:px-8 py-14 lg:py-20">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-ink-500 hover:text-cobalt-600 mb-8" data-testid="legal-back">
          <ArrowLeft size={14} weight="bold" /> Back to home
        </Link>
        {eyebrow && <div className="overline mb-3">{eyebrow}</div>}
        <h1 className="font-display font-bold text-4xl md:text-5xl tracking-tight" data-testid="legal-title">
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-3 text-sm text-ink-500">
            Last updated: <span className="font-semibold text-ink-700">{lastUpdated}</span>
          </p>
        )}
        {intro && <p className="mt-6 text-lg text-ink-700 leading-relaxed">{intro}</p>}
        <div className="mt-10 text-ink-800 leading-relaxed legal-body">
          {children}
        </div>
        <div className="mt-16 p-5 rounded-2xl bg-ink-50 border border-ink-200 text-sm text-ink-700">
          Questions? Email{" "}
          <a href="mailto:hello@blueroam.io" className="font-semibold text-cobalt-600 hover:underline">
            hello@blueroam.io
          </a>
          .
        </div>
      </article>
      <Footer />
    </div>
  );
}
